import { Seo } from "@/components/Seo";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background py-8 px-4 md:px-8">
      <Seo
        title="Privacybeleid · 2800.love"
        description="Hoe 2800.love omgaat met je persoonsgegevens: wat we verzamelen, waarom, en welke rechten je hebt onder de AVG."
        path="/privacy"
      />
      <div className="max-w-4xl mx-auto prose prose-sm md:prose-base">
        <h1 className="text-2xl md:text-3xl font-bold mb-6">Privacy Policy voor 2800.love</h1>
        
        <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">Inleiding</h2>
        <p>
          Deze Privacy Policy beschrijft hoe 2800.love (de "Website"), beheerd door Eskwadraat, eigendom van Stijn Swinnen ("wij", "ons", "onze"), omgaat met de persoonsgegevens die we verzamelen van gebruikers ("u", "uw") van de Website. We hechten veel waarde aan uw privacy en streven ernaar uw persoonsgegevens te beschermen in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG). Deze policy legt uit welke informatie we verzamelen, hoe we deze gebruiken, en welke rechten u heeft met betrekking tot uw gegevens.
        </p>
        <p>
          2800.love geeft bezoekers de mogelijkheid om het logo van 2800.love mee vorm te geven, inspireert met locaties in en rond Mechelen, en biedt een platform om foto's en persoonlijke ervaringen over favoriete plekken in Mechelen te delen.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">Welke gegevens we verzamelen:</h2>
        <p>
          We verzamelen gegevens die nodig zijn voor de functionaliteit van de website, zoals gegevens gerelateerd aan het ontwerpen van het hart-logo en de door u gedeelde ervaringen en favoriete plaatsen. Dit kan onder andere informatie bevatten die u zelf invult bij het delen van uw ervaringen.
        </p>
        <p>
          Daarnaast verzamelen wij automatisch bepaalde soorten gebruiksinformatie wanneer u onze Site bezoekt via trackingtechnologieën, waaronder cookies en vergelijkbare technologieën. Deze technologieën verzamelen onder andere:
        </p>
        <ul>
          <li>Informatie over uw apparaat en software (IP-adres, browsertype, internetprovider, etc.).</li>
          <li>Informatie over uw gebruik van de website (bezochte pagina's, kliks, etc.).</li>
          <li>Locatiegegevens (bij benadering, afhankelijk van uw apparaatinstellingen).</li>
        </ul>

        <p>We gebruiken deze gegevens om:</p>
        <ul>
          <li>Informatie te onthouden zodat u deze niet opnieuw hoeft in te voeren.</li>
          <li>De effectiviteit van onze services te controleren.</li>
          <li>Geaggregeerde statistieken over websitegebruik te verzamelen.</li>
          <li>Technische problemen te diagnosticeren en op te lossen.</li>
          <li>Onze services te verbeteren.</li>
        </ul>

        <p>
          <strong>Cookies uitschakelen:</strong> U kunt uw browserinstellingen aanpassen om cookies te blokkeren of om een melding te ontvangen wanneer een cookie wordt geplaatst. Houd er rekening mee dat dit de functionaliteit van de website kan beïnvloeden.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">Hoe we uw gegevens gebruiken:</h2>
        <p>
          De verzamelde gegevens worden gebruikt om de functionaliteit van de website te ondersteunen, zoals het weergeven van de gepersonaliseerde logo's en het delen van ervaringen met andere gebruikers. Gedeelde informatie wordt beschouwd als publieke informatie.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">Delen van gegevens met derden:</h2>
        <p>
          Wij delen uw gegevens niet met derden voor marketingdoeleinden. Wel maken we gebruik van de volgende dienstverleners die inzicht hebben in bepaalde gegevens en deze verwerken volgens hun eigen privacybeleid:
        </p>
        <ul>
          <li>Supabase: Voor database services. Raadpleeg hun privacybeleid op https://supabase.com/privacy.</li>
          <li>MailerLite: Voor e-mailcommunicatie. Raadpleeg hun privacybeleid op https://www.mailerlite.com/legal/privacy-policy.</li>
        </ul>

        <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">Bewaartermijn:</h2>
        <p>
          Uw persoonsgegevens worden bewaard tot u aangeeft dat u deze niet langer wenst te bewaren, of tot 60 dagen na uw verzoek tot verwijdering. Ingediende designs blijven bewaard, ook na verwijdering van uw persoonsgegevens. De link tussen uw gegevens en het design wordt in dat geval verbroken. Een gevalideerd design is een door de bezoeker gemaakte tekening. De bezoeker die een tekening maakt en doorstuurt, draagt alle intellectuele en gebruiksrechten over aan 2800.love.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">Beveiliging van uw gegevens:</h2>
        <p>
          We implementeren passende technische en organisatorische maatregelen om uw persoonsgegevens te beschermen. We zullen u nooit om creditcardgegevens of nationale identificatienummers vragen via ongevraagde e-mails of telefoontjes.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">Uw rechten:</h2>
        <p>
          U heeft het recht om uw persoonsgegevens in te zien, te corrigeren en te verwijderen. Neem hiervoor contact op met privacy@stijnswinnen.be.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">Kinderen:</h2>
        <p>
          Onze Service is niet gericht op personen jonger dan 13 jaar. We verzamelen niet bewust persoonsgegevens van kinderen jonger dan 13 jaar. Neem contact met ons op als u vermoedt dat uw kind ons persoonsgegevens heeft verstrekt.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">Contact:</h2>
        <p>
          Voor algemene vragen: contact@stijnswinnen.be<br />
          Voor privacy vragen: privacy@stijnswinnen.be
        </p>

        <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">Klacht indienen:</h2>
        <p>
          U kunt een klacht indienen bij de rechtbank van Mechelen.
        </p>

        <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">Toepasselijke wetgeving:</h2>
        <p>
          Deze Privacy Policy is onderworpen aan de AVG.
        </p>

        <p className="text-sm text-gray-600 mt-8">
          Laatst bijgewerkt: 15 december 2024
        </p>
      </div>
    </div>
  );
};

export default Privacy;